module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    attrs: {
      "id": "foot"
    }
  }, [_c('p', [_vm._v("Because Trump is 💩, "), _vm._t("default", [_vm._v("Seriously, WTF")]), _c('a', {
    staticClass: "top",
    class: {
      'show': _vm.showScroll
    },
    attrs: {
      "id": "scroller",
      "href": "#ftl"
    },
    on: {
      "click": _vm.scrollUp
    }
  }, [_c('icon', {
    attrs: {
      "name": "arrow-up",
      "scale": "1"
    }
  })], 1)], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0bf7472c"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = 1077
// module chunks = 1